import $ from "jquery";
import {ScreenWidthIsMobile} from "./general-functions";

export default class Navigation {

    // Elements
    siteHeaderElement = $('[data-id="site-header-inner"]');
    navigationToggleElement = $('[data-id="navigation-toggle"]');
    siteNavigationNavElement = $('[data-id="site-navigation-nav"]');

    // Flags
    menuIsOpen = false;

    constructor() {
        ScreenWidthIsMobile();
        this.ListenToToggleElement();

        //this.OnResize();
    }

    ListenToToggleElement() {
        this.navigationToggleElement.click((e) => {
            // Prevent element to do something else
            e.preventDefault();

            if(this.menuIsOpen) {
                this.menuIsOpen = false;
                this.DisableHamburgerMenu();
            } else {
                this.menuIsOpen = true;
                this.ActiveHamburgerMenu();
            }
        })
    }

    // Event-listener: listen to resize.
    OnResize() {
        $(window).on("resize", () => {
            ScreenWidthIsMobile();

            // Notice when screen width is a mobile device
            if(!ScreenWidthIsMobile) {
                if(this.menuIsOpen) {
                    this.menuIsOpen = false;
                    this.DisableHamburgerMenu();
                    this.siteNavigationNavElement.show();
                }
            }
        });
    };

    // Disable active state
    DisableHamburgerMenu() {
        this.siteHeaderElement.removeClass('site-header__inner--hamburger-active');
        this.siteNavigationNavElement.slideUp(250).removeClass('site-navigation__nav--hamburger-active');
        this.navigationToggleElement.removeClass('navigation-toggle--active');
    }

    // Active state
    ActiveHamburgerMenu() {
        this.siteHeaderElement.addClass('site-header__inner--hamburger-active');
        this.siteNavigationNavElement.delay(50).slideDown(250).addClass('site-navigation__nav--hamburger-active');
        this.navigationToggleElement.addClass('navigation-toggle--active');
    }
}